@if (lead) {
  <form novalidate [formGroup]="leadForm" (ngSubmit)="onSubmitForm(leadForm.value)">
    @if (showPrompt && promptAllowed) {
      <div class="selected-prompt-wraper">
        <div class="selected-prompt">
          @if (!isPromptFinished) {
            <div>
              @for (lender of availableSelected.lenders; track lender; let i = $index) {
                <div>
                  @if (lender.prompt_active) {
                    <div>
                      <h2 class="title is-size-4-mobile">
                        <span>Do you want to Get Rates from {{ lender.bank_name }}?</span>
                      </h2>
                      <div class="btn-wrapper">
                        <label class="checkbox-container">
                          <button type="button" class="button green continue is-large has-shadow-small" (click)="continueWith('yes')">
                            <input type="checkbox"  formArrayName="lenders_prompt" (change)="onCheckChange($event)" [value]="lender.id" [checked]="lender.prompt_checked">
                            <span class="checkmark"></span>
                            <span class="btn-main">Yes Get Rates*</span>
                            <i class="fas fa-chevron-right"></i>
                          </button>
                        </label>
                      </div>
                      <div>
                        <button type="button" class="button continue setno is-large has-shadow-small" (click)="continueWith('no')">
                          No&nbsp;&nbsp;&nbsp;&nbsp;
                          <i class="fas fa-chevron-right"></i>
                        </button>
                      </div>
                    </div>
                  }
                </div>
              }
              <div style="font-family: Tahoma; font-size: 14px; padding: 4px; margin-top: 40px;">
                *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
              </div>
            </div>
          }
          @if (isPromptFinished) {
            <div>
              Thank you! We redirect you on result page, please wait some seconds.
            </div>
          }
        </div>
      </div>
    }
    <input type="hidden" formControlName="encryptedLeadId">
    <div class="columns">
      <div class="column">
        <div class="field is-horizontal-mobile">
          <label class="label" for="firstName">First Name</label>
          <div class="control has-icons-left">
            <input class="input" type="text" formControlName="firstName" id="firstName">
            <span class="icon is-left">
              <i class="fas fa-user"></i>
            </span>
            @if (firstNameControl.errors?.required) {
              <p class="help is-danger">First Name is required.</p>
            }
            @if (firstNameControl.errors?.minlength) {
              <p class="help is-danger">First Name must be at least {{ firstNameControl.errors.minlength.requiredLength }} letters.</p>
            }
          </div>
        </div>
        <!-- <div class="field is-horizontal">
        <div class="field-label is-normal">
          <label class="label">Subject</label>
        </div>
        <div class="field-body">
          <div class="field">
            <div class="control">
              <input class="input is-danger" type="text" placeholder="e.g. Partnership opportunity">
            </div>
            <p class="help is-danger">
              This field is required
            </p>
          </div>
        </div>
      </div> -->
      <div class="field is-horizontal-mobile">
        <label class="label" for="lastName">Last Name</label>
        <div class="control has-icons-left">
          <input class="input" type="text" formControlName="lastName" id="lastName">
          <span class="icon is-left">
            <i class="fas fa-user"></i>
          </span>
          @if (lastNameControl.errors?.required) {
            <p class="help is-danger">Last Name is required.</p>
          }
          @if (lastNameControl.errors?.minlength) {
            <p class="help is-danger">Last Name must be at least {{ lastNameControl.errors.minlength.requiredLength }} letters.</p>
          }
        </div>
      </div>
      <div class="field is-horizontal-mobile">
        <label class="label" for="phone">Phone</label>
        <div class="control has-icons-left">
          <input class="input" type="phone" formControlName="phone" id="phone" [imask]="phoneMask">
          <span class="icon is-left">
            <i class="fas fa-phone"></i>
          </span>
          @if (phoneControl.errors?.required) {
            <p class="help is-danger">Phone Number is required.</p>
          }
          @if (phoneControl.errors?.pattern) {
            <p class="help is-danger">Invalid Phone Number.</p>
          }
        </div>
      </div>
      <div class="field is-horizontal-mobile">
        <label class="label" for="email">Confirm or correct your email for rate details</label>
        <div class="control has-icons-left">
          <input class="input" type="email" formControlName="email" id="email" autocomplete="email" inputmode="email">
          <span class="icon is-left">
            <i class="fas fa-envelope"></i>
          </span>
          @if (emailControl.touched && emailControl.errors?.required) {
            <p class="help is-danger">Email is required.</p>
          }
          @if (emailControl.touched && (emailControl.errors?.email || emailControl.errors?.pattern)) {
            <p class="help is-danger">Please enter a valid email address.</p>
          }
          @if (emailControl.touched && emailControl.errors?.server) {
            <p class="help is-danger">{{ serverEmailError }}</p>
          }
        </div>
      </div>
      @if (selectedEnabled && availableSelected.lenders.length > 0) {
        <div class="field lender-checkboxes">
          <h4 class="get_lendes_title" style="margin-bottom: 6px;">Get Rates from Checked Lenders <span>(Click <input type="checkbox" checked style="margin: 0px"> to Uncheck)</span></h4>
          <div class="columns">
            <div class="column">
              @for (lender of availableSelected.lenders; track lender; let i = $index) {
                <div class="control">
                  <label class="checkbox-container">
                    <input type="checkbox" id = "leadid_tcpa_brandname_0{{i+1}}" formArrayName="lenders" (change)="onCheckChange($event)" [value]="lender.id" [checked]="lender.checked">
                    <span class="checkmark"></span>
                    <label for = "leadid_tcpa_brandname_0{{i+1}}">{{ lender?.bank_name }}</label>
                  </label>
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (availableSelected.lead_id == 0 && selectedEnabled) {
        <div class="field lender-checkboxes has-text-centered mb-3 mt-4">
          <b><i class="fa fa-spinner fa-spin" aria-hidden="true"></i> Loading available lenders...</b>
        </div>
      }
      @for (notification of notifications; track notification) {
        <div class="notification is-{{notification.type}} is-light" [@fadeAnimation]="'in'">
          <button type="button" class="delete" aria-label="Dismiss notification" (click)="dismissNotification()"></button>
          {{notification.message}}
        </div>
      }
      <div class="field">
        <div class="control">
          <input type="hidden" name="universal_leadid" id="leadid_token" autocomplete="off" value="" />
          <button type="submit"
            class="button is-success is-fullwidth is-size-4 is-size-5-mobile has-text-weight-black has-shadow-large"
            [disabled]="!leadForm.valid || disableSubmit || (availableSelected.lead_id == 0 && selectedEnabled)">Get Rates@if (selectedEnabled) {
            <span>*</span>
          } &#12297;</button>
        </div>
      </div>
      <div class="field">
        @if (selectedEnabled) {
          <p class="tcpa is-size-7 has-text-grey-dark" >
            <input type="hidden" id="leadid_tcpa_disclosure_form">
            <label for="leadid_tcpa_disclosure_form">
              *By clicking "Get Rates" above, I am electronically signing this web-form and giving my express written consent for FreeRateUpdate.com LLC and the companies selected (checked) above to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgages and home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of automatically dialed voice calls and SMS/MMS messages and prerecorded or artificial voice messages. Message and data rates may apply. I acknowledge that there are up to 6 lenders pre-selected in the list above and that I may de-select any or all of them before I submit this web-form. By leaving lenders checked I am affirmatively choosing and consenting to receive mortgage and home equity marketing information from those lenders. To de-select lenders, I understand that I should click the checked box next to the lender’s name. I acknowledge that my consent is not required to obtain mortgage or home equity product marketing from FreeRateUpdate.com LLC or a mortgage or a home equity product from the company or companies listed above.
            </label>
          </p>
        }
        @if (!selectedEnabled) {
          <p class="tcpa is-size-7 has-text-grey-dark has-text-left" style="padding: 0 5px;">
            <input type="hidden" id="leadid_tcpa_disclosure_form">
            <label for="leadid_tcpa_disclosure_form" class="disclosure-text">
              @if (lead.propertyState !== 'NY') {
                <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC and its <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer">network of lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
              }
              @if (lead.propertyState === 'NY') {
                <span>*By entering my number and clicking the button above, I am electronically signing this web-form and giving my <strong>express written consent</strong> for FreeRateUpdate.com LLC, including its network members LoanDepot, Rocket Mortgage, <a href="/approved-lenders" target="_blank" rel="nofollow noopener noreferrer"> and other lenders, mortgage brokers, and agents/assigns</a> that may call or text on behalf of those companies to contact me at the phone number I have provided for purposes of providing marketing information regarding mortgage/home equity products, even if my number is listed on any company-specific, state, or federal Do-Not-Call list. This may include the use of voice calls and SMS/MMS messages that are dialed manually or by using an automatic telephone dialing system, and prerecorded, artificial or AI-generated voice messages. Message and data rates may apply. I can call 855-315-7283 for help and text STOP to cancel. I acknowledge that consent is not required as a condition to utilize the services of FreeRateUpdate.com LLC or any of its network of lenders, mortgage brokers, and agents and that I may instead choose to use those services by calling 855-315-7283.</span>
              }
              <br/><br/>
              I also agree to and am electronically signing FreeRateUpdate.com's @if (!fruLocalKiosk) {
              <a href="/privacy" target="_blank" rel="nofollow noopener noreferrer">Privacy Policy</a>
              } and its @if (!fruLocalKiosk) {
              <a href="/terms" rel="nofollow noopener noreferrer" target="_blank">Terms and Conditions</a>
              }.
            </label>
          </p>
        }
        <p class="is-flex is-flex-centered">
          <img src="/assets/images/bbb-a-plus-rating.gif" alt="BBB A+ Rated">
        </p>
      </div>
    </div>
  </div>
</form>
}
